import { SpeakerDto } from "./types";

export const data: SpeakerDto[] = [
  // {
  //   id: 28,
  //   avatar: "/uploads/podcast/avatar-eoviawe.jpg",
  //   firstName: "Dr. Ephraim",
  //   surname: "Oviawe",
  //   displayName: "Dr. Ephraim",
  //   email: "",
  //   tel: "+16462011615",
  //   occupation: "Project Manager",
  //   bio: "Founder, ECONTEUR LLC",
  //   location: {
  //     city: "Georgia",
  //     country: "US",
  //     flag: "/uploads/podcast/flag-us.webp",
  //   },
  //   socials: { x: "", in: "" },
  // },
  {
    id: 27,
    avatar: "/uploads/podcast/avatar-toluwawemimo.png",
    firstName: "Tolulope",
    surname: "Oluwawemimo",
    displayName: "Tolulope O.",
    sex: "f",
    email: "faithlope4real@gmail.com",
    tel: "+2348061583213",
    occupation: "Project Manager",
    bio: "Founder, The PM & Ops Lab",
    location: {
      city: "Lagos",
    },
    socials: { x: "@faithlope4real", in: "lorpe-faith" },
  },
  {
    id: 26,
    avatar: "/uploads/podcast/avatar-aalebiowu.jpg",
    firstName: "Emmanuel `Ayo`",
    surname: "Alebiowu",
    displayName: "Ayomide A.",
    email: "misteralebiowu@gmail.com",
    tel: "+2348033852776",
    occupation: "Public Health Professional",
    bio: "Public Health Professional, UCH",
    location: { city: "Edo" },
    socials: {
      x: "@manuelalebiowu",
      in: "",
    },
  },
  {
    id: 25,
    avatar: "/uploads/podcast/avatar-cking.jpg",
    firstName: "Chinemerem",
    surname: "King",
    displayName: "King C.",
    email: "nwankpachinemerem@gmail.com",
    tel: "+2348149193063",
    occupation: "Product Manager",
    bio: "Founder, Bauchi State Development Initiative (BDI)",
    location: { city: "Bauchi" },
    socials: {
      x: "@Chinemerem57508",
      in: "chinemerem-king-67a982248",
    },
  },
  {
    id: 24,
    avatar: "/uploads/podcast/avatar-pgodwin.jpg",
    firstName: "Princewill",
    surname: "Godwin",
    displayName: "P Craft",
    email: "princewillg6@gmail.com",
    tel: "+2348103840238",
    occupation: "Product Designer",
    bio: "Product Designer, Brightson Autos",
    location: { city: "Ondo" },
    socials: {
      x: "@Princewill1_G",
      in: "princewill-godwin-uiuxdesigner",
    },
  },
  {
    id: 23,
    avatar: "/uploads/podcast/avatar-tuvietobore.jpg",
    firstName: "Treasure",
    surname: "Uvietobore",
    displayName: "Treasure U.",
    email: "uvietoboretreasure@gmail.com",
    tel: "+2348157002782",
    occupation: "Software Engineer",
    bio: "Technical Rep, Binx AI",
    website: "usebinx.com",
    location: { city: "Lagos" },
    socials: {
      x: "@treasure_devops",
      in: "treasure-uvietobore",
    },
  },
  {
    id: 22,
    avatar: "/uploads/podcast/avatar-nolaide.jpg",
    firstName: "Naheem",
    surname: "Olaide",
    displayName: "Naheem O.",
    email: "appdever01@gmail.com",
    tel: "+2347049972537",
    occupation: "Software Engineer",
    bio: "Founder/CEO, Binx AI",
    website: "usebinx.com",
    location: {
      city: "Lagos",
    },
    socials: { x: "@naheem__x", in: "naheemolaide" },
  },
  {
    id: 21,
    avatar: "/uploads/podcast/avatar-vogundowo.png",
    firstName: "Victor",
    surname: "Ogundowo",
    displayName: "Victor I.",
    email: "vicosoft4real@gmail.com",
    tel: "+2348060956363",
    occupation: "Software Engineer",
    bio: "Founder, Vicomeg",
    website: "vicomeg.com",
    location: {
      city: "Lagos",
    },
    socials: {
      x: "@vicosoft4real",
      in: "vicosoft",
      email: "support@vicomeg.com",
    },
  },
  {
    id: 20,
    avatar: "/uploads/podcast/avatar-fike.png",
    firstName: "Franklin",
    surname: "Ike",
    displayName: "Franklin I.",
    email: "frankline95.ii@gmail.com",
    tel: "+2349038503700",
    occupation: "CEO, Thesinova Consulting",
    bio: "Data Scientist, ML Engineer",
    website: "thesinova.com",
    location: {
      city: "Asaba",
    },
    socials: {
      x: "@bloginfoheap",
      in: "franklin-ike",
      email: "anyiglobal95.ii@gmail.com;contact@thesinova.com",
    },
  },
  {
    id: 19,
    avatar: "/uploads/podcast/avatar-jusen.jpg",
    firstName: "Jabulani",
    surname: "Usen",
    displayName: "Jabulani U.",
    email: "jabulanietokakpan@gmail.com",
    tel: "+2349063525949",
    occupation: "Software Engineer",
    bio: "Founder/CEO, LANI",
    website: "jabulaniusen.com",
    location: {
      city: "Oyo",
    },
    socials: { x: "@JabulaniUsen" },
  },
  {
    id: 18,
    avatar: "/uploads/podcast/avatar-saiyeduyoni.jpg",
    firstName: "Samuel",
    surname: "Aiyeduyoni",
    displayName: "Samuel A.",
    email: "samaiye2018@gmail.com",
    tel: "+234806066696",
    occupation: "Systems Engineer",
    bio: "CEO, SAT Integrated Concepts",
    location: {
      city: "Edo",
    },
    socials: { x: "@samaiye2018" },
  },
  {
    id: 17,
    avatar: "/uploads/podcast/avatar-hoshomoh.png",
    firstName: "H. M.",
    surname: "Oshomoh",
    displayName: "Harrison O.",
    email: "harrison.oshomoh@gmail.com",
    tel: "+2347066416750",
    occupation: "Software Engineer",
    bio: "Assistant Lecturer, OAU",
    location: {
      city: "Osun",
    },
    socials: {
      x: "@mr_oshomoh",
      in: "harrisonoshomoh",
      ig: "mr_oshomoh",
      tk: "@harrisonoshomoh",
      git: "",
    },
  },
  {
    id: 16,
    avatar: "/uploads/podcast/avatar-wemmanuel.png",
    firstName: "Witney",
    surname: "Emmanuel",
    displayName: "Witney E.",
    sex: "f",
    email: "favoureboselume@gmail.com",
    tel: "+2348105471734",
    occupation: "Pragmatist",
    bio: "CEO, Witney Royale Couture",
    location: {
      city: "Edo",
    },
    socials: { x: "@simplywitney", ig: "witney_royalecouture" },
  },
  {
    id: 15,
    avatar: "/uploads/podcast/avatar-tadegoke.png",
    firstName: "Temi",
    surname: "Adegoke, PSM",
    displayName: "Temi A.",
    sex: "f",
    email: "adegokeesther03@gmail.com",
    tel: "+2347036905176",
    occupation: "Project Manager",
    bio: "IT Project Manager, Powertech",
    location: {
      city: "Lagos",
    },
    socials: { x: "@i_amtemiloluwa", ig: "awo_oore", in: "temiloluwadegoke" },
  },
  {
    id: 14,
    avatar: "/uploads/podcast/avatar-sgbangbola.png",
    firstName: "Seyi",
    surname: "Gbangbola",
    displayName: "Seyi G.",
    email: "hgbangbola@midontario.ca",
    tel: "+14372433103",
    occupation: "Politician",
    bio: "Founder, Tribe Alliance for Nigeria",
    location: {
      city: "Toronto",
      country: "CA",
      flag: "/uploads/podcast/flag-ca.webp",
    },
    socials: { x: "@HGbangbola" },
  },
  {
    id: 13,
    avatar: "/uploads/podcast/avatar-jgodfrey.png",
    firstName: "Jamiah",
    surname: "Godfrey",
    displayName: "Jamiah G.",
    email: "jamiahgodfrey247@gmail.com",
    tel: "+2347059476231",
    occupation: "Musician",
    bio: "Gospel Artist & Song Writer",
    location: { city: "Edo" },
    socials: { x: "@JamiahGodfrey" },
  },
  {
    id: 12,
    avatar: "/uploads/podcast/avatar-eonyebinamma.jpg",
    firstName: "Ebuka",
    surname: "Onyebinamma",
    displayName: "Ebuka O.",
    email: "ebukapeter143@gmail.com",
    tel: "+2348164633970",
    occupation: "Tech Lead",
    bio: "Software Engineer, #",
    location: { city: "Edo" },
    socials: { x: "@peterdbrainy5" },
  },
  {
    id: 11,
    avatar: "/uploads/podcast/avatar-eokene.jpg",
    firstName: "Emmanuel",
    surname: "Okene",
    displayName: "Okene E.",
    email: "okene_e@yahoo.com",
    tel: "+2348139543769",
    occupation: "Scientific Officer",
    bio: "Health Data Analyst/NHIA, UBTH",
    location: { city: "Edo" },
    socials: { x: "@emmanuelokene44" },
  },
  {
    id: 10,
    avatar: "/uploads/podcast/avatar-lkolapo.jpg",
    firstName: "Linda",
    surname: "Kolapo",
    displayName: "Linda K.",
    sex: "f",
    email: "ogokolapo@gmail.com",
    tel: "+2349013696053",
    occupation: "Communication Strategist",
    bio: "Communication Strategist, Siiqo",
    website: "siiqo.com",
    location: { city: "Delta" },
    socials: { in: "linda-kolapo", x: "@kolapo_gemini" },
  },
  {
    id: 9,
    avatar: "/uploads/podcast/avatar-oinnocent.jpg",
    firstName: "Okereke",
    surname: "Innocent",
    displayName: "Okereke I.",
    email: "okerekeinno6@gmail.com",
    tel: "+2347035360986",
    occupation: "Product Engineer",
    bio: "Founder/CTO, Siiqo",
    website: "siiqo.com",
    location: { city: "Abuja" },
    socials: { in: "okereke-chinweokwu-388657129", x: "@OkerekeChinweo1" },
  },
  {
    id: 8,
    avatar: "/uploads/podcast/avatar-polalere.png",
    firstName: "Phillip",
    surname: "Olalere",
    displayName: "Phillip O.",
    email: "phil.olalere@gmail.com",
    tel: "+447823518982",
    occupation: "Software Engineer",
    bio: "Software Engineer, #",
    location: {
      city: "Colorado",
      country: "US",
      flag: "/uploads/podcast/flag-us.webp",
    },
    socials: { in: "phillip-olalere-a66929157", x: "@philstring93" },
  },
  {
    id: 7,
    avatar: "/uploads/podcast/avatar-aosawere.png",
    firstName: "Anthony",
    surname: "Osawere",
    displayName: "AO",
    email: "anthony@osawere.com",
    tel: "+447377500940",
    occupation: "Solution Architect",
    bio: "Software Engineer, #",
    website: "osawere.com",
    location: { country: "UK", flag: "/uploads/podcast/flag-uk.webp" },
    socials: { in: "osawereao", x: "@workofao" },
  },
  {
    id: 6,
    avatar: "/uploads/podcast/avatar-iadebiyi.png",
    displayName: "Isaac A.",
    firstName: "Isaac",
    surname: "Adebiyi",
    email: "theisaacade@gmail.com",
    tel: "+2348125205572",
    occupation: "Brand Strategist",
    bio: "Founder/CEO, Adiz Media",
    location: { city: "Lagos" },
    socials: { ig: "adizmedia", x: "@theisaacade" },
  },
  {
    id: 5,
    avatar: "/uploads/podcast/avatar-aolueh.jpg",
    displayName: "Aboyowa O.",
    firstName: "Aboyowa",
    surname: "Olueh",
    email: "oluehaboyowa@gmail.com",
    tel: "+2347062963987",
    occupation: "Founder",
    bio: "Founder, Tetra",
    website: "usetetra.com",
    location: { city: "Edo" },
    socials: { in: "aaybee", x: "@OluehAboyowa" },
  },
  {
    id: 4,
    avatar: "/uploads/podcast/avatar-juyi.png",
    firstName: "Joshua",
    surname: "Uyi",
    displayName: "Joshua U.",
    email: "joshuaouyi@gmail.com",
    tel: "+2348168499179",
    occupation: "Solution Architect",
    bio: "Founder/CEO, Izivote",
    website: "izivote.com",
    location: { country: "CA", flag: "/uploads/podcast/flag-ca.webp" },
    socials: { in: "joshua-uyi", x: "@joshuaouyi" },
  },
  {
    id: 3,
    avatar: "/uploads/podcast/avatar-oifeanyi.png",
    displayName: " Oluchi I.",
    firstName: "Oluchi",
    surname: "Ifeanyi",
    email: "ifeanyioluchi7@gmail.com",
    tel: "+2347042434285",
    occupation: "Software Engineer",
    bio: "Founder, Bookin",
    website: "usebookin.com",
    location: { city: "Lagos" },
    socials: { in: "ifeanyi-oluchi-6002282243", x: "@feanyluch" },
  },
  {
    id: 2,
    avatar: "/uploads/podcast/avatar-makinbo.png",
    firstName: "Martins",
    surname: "Akinbo",
    displayName: "Martins A.",
    email: "aktech11@gmail.com",
    tel: "+2347051129657",
    occupation: "CTO",
    bio: "Founder/CTO, Technox Solutions Ltd",
    website: "scupex.com",
    location: { city: "Lagos" },
    socials: { in: "imakinbo", x: "@sanmiAkinbo" },
  },
  {
    id: 1,
    avatar: "/images/avatar-etugbeh.png",
    firstName: "Emmanuel",
    surname: "Tugbeh",
    displayName: "Emanuel",
    email: "etugbeh@outlook.com",
    tel: "+2348169960927",
    occupation: "Software Engineer",
    // bio: "Principal Software Engineer, UNIBEN",
    bio: "AI Product Engineer, HWP Labs",
    website: "northwindai.org",
    location: { city: "Edo" },
    socials: { in: "2gbeh", x: "@2gbeh", tk: "@2gbeh", git: "2gbeh" },
    host: true,
  },
];
